import { FC } from 'react'
import { SvgProps } from '@/components/atoms/svg/svgProps'
const SweatshirtsMen: FC<SvgProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 142.45 154"
      width={width || 18}
      height={height || 18}
    >
      <use href="#sweatshirts-men-icon-definition" stroke={color || '#000'} />
    </svg>
  )
}
export default SweatshirtsMen
